<template>
  <div class="levelMessage">
    <svg class="icon-tip">
      <use xlink:href="#icon-shibaifuzhi5"></use>
    </svg>
    <span class="msg-text">{{ msg }}</span>
    <span class="level-light" @click="openLevel">去升级</span>
    <svg class="icon-close" @click="onMClick">
      <use xlink:href="#icon-guanbi1"></use>
    </svg>
  </div>
</template>

<script>
  import { message } from 'ant-design-vue'
  export default {
    name: 'levelMessage',
    props: ['msg'],
    methods: {
      onMClick() {
        message.destroy()
      },
      openLevel() {
        window.open('/go/tsp_pc_login/home/price')
      },
    },
  }
</script>

<style scoped lang="less">
  .levelMessage {
    display: flex;
    align-items: center;
    span {
      height: 22px;
      font-size: 14px;
      line-height: 22px;
      color: #333333;
    }
    .msg-text {
      margin-left: 16px;
      margin-right: 16px;
    }
    .level-light {
      color: #00befa;
      margin-right: 16px;
      cursor: pointer;
    }
    .icon-tip {
      fill: #f55c3f;
      width: 16px;
      height: 16px;
    }
    .icon-close {
      width: 19px;
      height: 19px;
      cursor: pointer;
    }
  }
</style>
